export const padding = 1;
export const margin = 1;
export const elevation = 1;